import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import PageTitle from 'components/shared/page-title/page-title.component';
import ManageTags from './tags/manage-tags.component';

const OrderTagsSettings: FC = () => {
    const { t: translate } = useTranslation(['lab-settings']);

    return (
        <Fragment>
            <PageTitle headingStyle="h2" title={translate('lab-settings:ORDER_TAGS')} />
            <Grid container>
                <Grid item sm={12} md={8}>
                    <ManageTags />
                </Grid>
            </Grid>
        </Fragment>
    );
};

export default OrderTagsSettings;
